import { usePageViewedEvent } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';

export const useLoginViewed = (params = {}) => {
  usePageViewedEvent({ event: EVENTS.LOGIN_VIEWED, params });
};
